import rewardsGetters from "./getters.js";
import rewardsMutations from "./mutations.js";
import rewardsActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      rewardsTimestamp: null,
      rewards: [],
      claims: [],
      pendingClaims: 0,
    };
  },
  getters: rewardsGetters,
  mutations: rewardsMutations,
  actions: rewardsActions,
};
